import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { HighlightTextComponent } from './highlight-text.component';

@NgModule({
  imports: [CommonModule],
  declarations: [HighlightTextComponent],
  exports: [HighlightTextComponent],
})
export class HighlightTextModule {}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/de/webapp/src/app/@shared/ui/highlight-text/highlight-text.module.ts